// TODO: Import React module
import * as React from 'react';
import {
    BrowserRouter as Router,
    Routes,
    Route,
} from 'react-router-dom'

// TODO: Import MUI module;

// TODO: Import MUI icon;

// TODO: Import custom component
import MenuBar from './MenuBar.js';
import PageHome from './PageHome.js';
import PagePlant from './Plant/PagePlant.js';

import ScrollTo from './ScrollTo.js';

export default function YiYuan() {
    // TODO: Define useContext

    // TODO: Define variable

    // TODO: Define event

    // TODO: Define function

    // TODO: Return component
    const basename = window.location.hostname === 'www.pohtyh.edu.hk' ? '/YiYuan' : '/';

    return (
        <Router basename={basename}>
            <MenuBar />
            <ScrollTo />
            <Routes>
                <Route element={<PageHome />} path="/"></Route>
                <Route element={<PagePlant />} path="/Plant"></Route>
            </Routes>
        </Router>
    );
}